import React from 'react';
import styled from 'styled-components'
import { useSetting } from '../../../shared/hooks/useApi/useSetting';
import { useCheckBeforeMove } from '../../../shared/hooks/useCheckBeforeMove';
import { usePageOwnerIdentityStore } from '../../../shared/store/pageOwnerIdentityStore';
import { useNavigate } from 'react-router-dom';

const LnbLogoUsernameFixed: React.FC = () => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { setting } = useSetting();
  const { getCurrentPage } = useCheckBeforeMove();
  const navigate = useNavigate();

  const handleUsernameClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!pageOwner) return;
    e.stopPropagation();
    if (getCurrentPage().page === 'billboard') return;
    navigate(`/@${pageOwner.handle}/`);
  }

  if (!setting) return null;

  return (
    <LnbLogoUsernameComp>
      <Username onClick={(e) => handleUsernameClick(e)}>
        {setting.username}
      </Username>
    </LnbLogoUsernameComp>
  )
}

const LnbLogoUsernameComp = styled.section`
  width: 100%;
  height: 7.5vh;
  display: flex;
  align-items: center;
  gap: 0.7vw;
  padding: 0.5vw clamp(12px, 1.2vw, 1.2vw);
  overflow: hidden;
  margin-bottom: 6vh;
`;

const Username = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  &:hover {
    text-decoration: ${({ theme }) => theme.fontWeight.decoration};
  }
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_03_1};
  pointer-events: auto;
`;


export default LnbLogoUsernameFixed;
